import { useState } from "react";
import { Wrench, Lock, ExternalLink } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { EstimateLines } from "@/components/EstimateLines";

// The "Sold As-Is" badge on the QR page. When the dealer shares the estimate it becomes a tap target:
// walled → lead wall; document → opens the shop's PDF/photo; line items only → inline list.
export function AsIsBadge({ vehicle: v, unlocked, walled, onWall }) {
  const [linesOpen, setLinesOpen] = useState(false);
  const estimateUrl = v.estimate_url || unlocked?.estimate_url;
  const items = v.repair_items?.length ? v.repair_items : unlocked?.repair_items || [];
  const total = v.repair_estimate_total || unlocked?.repair_estimate_total || 0;
  const cls = "bg-amber-500 hover:bg-amber-400 text-black font-bold";

  if (!v.has_estimate) {
    return (
      <Badge data-testid="vehicle-as-is-badge" title="Sold As-Is — needs work to pass state inspection" className={cls}>
        Sold As-Is
      </Badge>
    );
  }
  if (walled && !estimateUrl && !items.length) {
    return (
      <button type="button" onClick={onWall} data-testid="vehicle-as-is-badge" className="inline-flex">
        <Badge className={`${cls} cursor-pointer`}><Lock className="mr-1 h-3 w-3" /> Sold As-Is · view repair estimate</Badge>
      </button>
    );
  }
  if (estimateUrl) {
    return (
      <a href={estimateUrl} target="_blank" rel="noopener" data-testid="vehicle-as-is-badge" className="inline-flex">
        <Badge className={`${cls} cursor-pointer`}><Wrench className="mr-1 h-3 w-3" /> Sold As-Is · view repair estimate <ExternalLink className="ml-1 h-3 w-3" /></Badge>
      </a>
    );
  }
  return (
    <>
      <button type="button" onClick={() => setLinesOpen(true)} data-testid="vehicle-as-is-badge" className="inline-flex">
        <Badge className={`${cls} cursor-pointer`}><Wrench className="mr-1 h-3 w-3" /> Sold As-Is · est. ${Math.round(total).toLocaleString()} to pass inspection</Badge>
      </button>
      <Dialog open={linesOpen} onOpenChange={setLinesOpen}>
        <DialogContent data-testid="estimate-dialog" className="bg-[#0F111A] border-[#2A2E3D] text-white max-w-md">
          <DialogHeader>
            <DialogTitle className="font-heading text-xl font-extrabold flex items-center gap-2"><Wrench className="h-5 w-5 text-amber-400" /> Repair estimate</DialogTitle>
            <DialogDescription className="text-slate-400">{v.year} {v.make} {v.model} · sold As-Is</DialogDescription>
          </DialogHeader>
          <EstimateLines items={items} total={total} />
        </DialogContent>
      </Dialog>
    </>
  );
}
